export default "__VITE_ASSET__a7745555__"